import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { MULTIPLIER_BG_COLOR } from '@/feature/betslip-pickem/utils/game-mode-utils';
import { toLocaleCurrency } from '@/utils/numeric/currency';

export const PayoutLine = ({
    description,
    multiplier,
    boostedMultiplier,
    mysteryMultipliers,
    amount,
    winningAmount,
    activeDollarSignsNumber = 4,
    dollarSignsNumber,
    rightLabel,
    dynamicPayout,
    hidePayoutDetails = false,
    hideMultiplier = false,
}: {
    description?: string;
    amount?: number;
    multiplier?: string | number;
    boostedMultiplier?: number;
    mysteryMultipliers?: { min: number; max: number };
    winningAmount?: string | number;
    dollarSignsNumber: number;
    activeDollarSignsNumber?: number;
    hidePayoutDetails?: boolean;
    hideMultiplier?: boolean;
    dynamicPayout?: boolean;
    rightLabel?: string;
}) => {
    let multiplierText;
    if (mysteryMultipliers) {
        multiplierText = `${mysteryMultipliers.min}x - ${mysteryMultipliers.max}x`;
    } else if (boostedMultiplier === undefined && multiplier === undefined) {
        multiplierText = undefined;
    } else {
        multiplierText = `${boostedMultiplier && boostedMultiplier > 0 ? boostedMultiplier : multiplier}x`;
    }

    return (
        <Row paddingVertical={'s8'} justifyContent={'space-between'} alignItems={'center'}>
            {/** Left text - multiplier */}
            <Row flex={1} minWidth={0} alignItems={'center'}>
                {description ? (
                    <Text
                        mr={'s8'}
                        variant={'bodyMedium'}
                        color={ds.colorToken.text.primary}
                        style={styles.description}
                        numberOfLines={1}
                        ellipsizeMode={'tail'}
                    >
                        {description}
                    </Text>
                ) : null}
                {!hidePayoutDetails && !hideMultiplier && multiplierText ? (
                    <Row paddingVertical={'s4'} mr={'s16'} borderRadius={'r7'} style={styles.multiplier} flexShrink={0}>
                        <Text variant={'labelMedium'} color={ds.colorToken.text.brand}>
                            {multiplierText}
                        </Text>
                    </Row>
                ) : null}
            </Row>
            {/** Right text -  Payout | Frequency */}
            <Row flexShrink={0}>
                {rightLabel ? (
                    <Text variant={'bodyMedium'} color={ds.colorToken.text.primary}>
                        {rightLabel}
                    </Text>
                ) : null}
                {amount && winningAmount && !hidePayoutDetails ? (
                    <>
                        <Text variant={'bodyMedium'} color={'neutral300'}>
                            {`${toLocaleCurrency(amount)} ${dynamicPayout ? 'wins up to' : 'wins'} `}
                        </Text>
                        <Text variant={'bodyMedium'} color={ds.colorToken.text.brand}>
                            {toLocaleCurrency(winningAmount)}
                        </Text>
                    </>
                ) : (
                    <Row>
                        <Text variant={'bodyMedium'} textAlign={'right'} letterSpacing={-0.23}>
                            {Array.from({ length: dollarSignsNumber }).map((_, index) => (
                                <Text
                                    key={index}
                                    color={index < activeDollarSignsNumber ? ds.colorToken.text.primary : 'neutral400'}
                                >
                                    $
                                </Text>
                            ))}
                        </Text>
                    </Row>
                )}
            </Row>
        </Row>
    );
};

const styles = StyleSheet.create({
    multiplier: {
        paddingHorizontal: 7,
        backgroundColor: MULTIPLIER_BG_COLOR,
    },
    description: {
        flexShrink: 1,
    },
});
